// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2NILE","left":"InfoRow_left__1ulf8"};